<template>
    <div class="item-default __item-special">
        <div class="image">
            <ion-skeleton-text></ion-skeleton-text>
        </div>
        <div class="description">
            <div class="head">
                <ion-skeleton-text animated style="width:120px;"></ion-skeleton-text>
            </div>
            <h3 class="title h5">
                <ion-skeleton-text animated style="width:60%;"></ion-skeleton-text>
            </h3>
            <div class="excerpt">
                <ion-skeleton-text animated style="width:80%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width:55%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width:70%"></ion-skeleton-text>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ItemSpecialsSkeleton'
    }
</script>

<style lang="scss" scoped>
    .image {
        height: 100%;
        ion-skeleton-text {
            line-height: 130px;
        }
    }
    .title {
        ion-skeleton-text {
            line-height: 18px;
            margin-bottom: 6px;
        }
    }
    .excerpt {
        ion-skeleton-text {
            line-height: 13px;
            margin-bottom: 5px;
        }
    }

</style>